import * as x from '../helpers/xmlHelpers';

export class Relationships {
    constructor(doc) {
        this.relationshipList = [];

        var relationships = x.selectNodes(doc, "./ns:RELATIONSHIPS/ns:RELATIONSHIP");
        relationships.forEach((relationship) => {
            this.relationshipList.push(new Relationship(relationship));
        });
    }

    GetRelationshipsTo(arc, to) {
        const list = [];
        for (let relationship of this.relationshipList) {
            if (relationship.arcrole === arc && relationship.to === to) {
                list.push(relationship.from);
            }
        }
        return list;
    }

    GetRelationshipsFrom(arc, from) {
        const list = [];
        for (let relationship of this.relationshipList) {
            if (relationship.arcrole === arc && relationship.from === from) {
                list.push(relationship.to);
            }
        }
        return list;
    }

    GetRelationshipsByArcFrom(arc) {
        const list = [];
        for (let relationship of this.relationshipList) {
            if (relationship.arcrole === arc) {
                list.push(relationship.from);
            }
        }
        return list;
    }

    GetRelationshipsByArcFromTo(arc) {
        const list = [];
        for (let relationship of this.relationshipList) {
            if (relationship.arcrole === arc) {
                let ft = 
                {
                    from: relationship.from,
                    to: relationship.to
                }
                list.push(ft);
            }
        }
        return list;
    }


    GetRelationshipsByRole(arcRole) {
        const list = [];
        for (let relationship of this.relationshipList) {
            if (relationship.arcrole.endsWith(arcRole)) {
                list.push(relationship);
            }
        }
        return list;
    }
}

export class Relationship {
    constructor(doc)
    {
        this.arcrole = null
        this.from = null
        this.to = null
        this.type = "";

        this.arcrole = x.getStringAttribute(doc,"xlink:arcrole");
        var ix = this.arcrole.indexOf("/");
        if (ix >= 0)
        {
            this.arcrole = this.arcrole.substring(ix+1);
            if (this.arcrole.startsWith("DATA_SOURCE"))
                this.type = "DataSource";
            else if (this.arcrole.startsWith("SIGNATORY"))
                this.type = "Signatory";
            else if (this.arcrole.startsWith("DEFECT"))
                this.type = "Defect";
            else if (this.arcrole.startsWith("INSPECTION"))
                this.type = "Inspection";
            else 
                this.type = "Other";
        }

        this.from = x.getStringAttribute(doc,"xlink:from");
        this.to = x.getStringAttribute(doc,"xlink:to");
        //console.log("rel: ", this.arcrole, this.from, this.to);
    }
}

